import { findIndex, propEq } from 'ramda';

/**
 * Finds and element on `list` by its `id` and returns it index.
 * @param {Number} id The identifier to search for
 * @param {Array} list The array to search on
 * @returns {Number} The index of the found element, or `-1` if it wasn't found
 */
export const findIndexById = (id, list) => findIndex(propEq('id', id), list);
